'use strict';

/**

 * SkutinGram

 * microframefork core

 * 

 * Author: Alex Skutin [skutin.pro]

 */

window.sg = new (function(w, d) {

	///////////////////

	// Private props

	///////////////////

	var _sg = this,

		_config = null,

		_currentRoute = null,

		_inited = false,

		_ready = null,

		_loaded = null,

		_routes = {},

		_modulesData = {};



	///////////////////

	// Private methods

	///////////////////



	var _initCore = function() {

			if (_inited) return;



			_initDocReady();

			_initDocLoad();

			_initUnload();



			_inited = true;

			_sg.trigger('init');

		},

		_initDocReady = function() {

			if (_ready !== null) return;

			_ready = false;



			var _setReady = function() {

				if (_ready || !d.readyState || d.readyState === 'loading')

					return false;



				_ready = true;

				_sg.trigger('ready');



				(d.removeEventListener && d.removeEventListener('DOMContentLoaded', _setReady))

				|| (d.detachEvent && d.detachEvent('onreadystatechange', _setReady));



				return true;

			};



			if (_setReady()) {

				return;

			}



			(d.addEventListener && d.addEventListener('DOMContentLoaded', _setReady))

			|| (d.attachEvent && d.attachEvent('onreadystatechange', _setReady));

		},

		_initDocLoad = function() {

			if (_loaded !== null) return;

			_loaded = false;



			var _sgttach = null,

				_detach = null,

				_event = null,

				_setLoaded = function() {

					if (!_ready) {

						_ready = true;

						_sg.trigger('ready');

					}

					if (_loaded) return false;



					_loaded = true;

					_sg.trigger('load');



					if (_detach) {

						_detach(_event, _setLoaded);

					}

					return true;

				};



			if (d.readyState && d.readyState === 'complete') {

				_setLoaded();

				return;

			}



			if (w.addEventListener) {

				_sgttach = w.addEventListener;

				_detach = w.removeEventListener;

				_event = 'load';

			} else if (w.attachEvent) {

				_sgttach = w.attachEvent;

				_detach = w.detachEvent;

				_event = 'onload';

			}



			if (_sgttach) {

				_sgttach(_event, _setLoaded);

			} else if ('onload' in w) {

				w.onload = _setLoaded;

			} else {

				_setLoaded();

			}

		},

		_initUnload = function() {

			var _unloaded = false,

				_unload = function() {

					if (_unloaded) return;

					_unloaded = true;

					_sg.trigger('unload');

				};

			

			w.addEventListener('beforeunload', _unload, false);

			w.addEventListener('unload', _unload, false);

			w.onbeforeunload = _unload;

		},

		_dispatch = function(params) {

			var involved = false;



			_currentRoute = w.location.pathname;



			if (_config.routeHash) {

				_currentRoute = w.location.hash.substring(1);

			}



			if (_currentRoute.charAt(_currentRoute.length - 1) !== '/') {

				_currentRoute += '/';

			}



			for (var name in _modulesData) {

				involved = _dispatchModule.call(_sg, name, params);

			}

		},

		_dispatchModule = function(moduleName, params) {

			if (!_routes[moduleName]) {

				return;

			}



			var involved = false,

				moduleEvent = null;



			for (var i = 0, rule; (rule = _routes[moduleName].rules[i]); i++) {

				involved = _sg.string.match(_currentRoute, rule);



				if (involved) {

					break;

				}

			}



			if (involved) {

				_modulesData[moduleName].readyPromise.then(function() {

					_involveModule(moduleName, params);

				}).catch(function() {

					_sg.logError.apply(this, arguments);

				});

			} else {

				_detachModule(moduleName, params);

			}



			return involved;

		},

		_involveModule = function(moduleName, params) {

			var moduleEvent = _sg[moduleName].getState('involved')

				? 'reinit'

				: 'init';

			_sg[moduleName].setState('involved', true);

			_sg[moduleName].trigger(moduleEvent, params);

		},

		_detachModule = function(moduleName, params) {

			var moduleEvent = _sg[moduleName].getState('involved')

				? 'destroy'

				: null;

			_sg[moduleName].setState('involved', false);

			moduleEvent && _sg[moduleName].trigger(moduleEvent, params);

		},

		_dataToError = function (data) {

			var d = {};



			if (data) {

				if (typeof data === 'string') {

					d.message = data;

				} else if (typeof data === 'object') {

					d = data;

				}

			}



			var result = {

				name: d.name || 'Error',

				message: d.message || d.description || 'JS error',

				fileName: d.fileName || '',

				lineNumber: d.lineNumber || 0,

				columnNumber: d.columnNumber || 0,

				stack: d.stack || (new Error()).stack,

				level: d.level || 100

			};



			if (data && typeof data === 'object') {

				for (var key in data) {

					result[key] = data[key];

				}

			}



			return result;

		};



	///////////////////

	// Public methods

	///////////////////



	this._sgStore = {

		handlers: {},

		states: {}

	};

	this.w = w;

	this.doc = d;

	this.html = d.documentElement;

	this.body = d.body;



	this.api = w.telegramApi || {};



	this.l = function() {

		w.console && w.console.log.apply(w, arguments);

	};



	this.w = function() {

		w.console && w.console.warn.apply(w, arguments);

	};



	this.e = function() {

		w.console && w.console.error.apply(w, arguments);

	};



	this.t = function() {

		w.console && w.console.trace.apply(w, arguments);

	};



	this.reload = function(forcedReload) {

		d.location.reload(forcedReload);

	};



	this.getRoot = function() {

		return _config.root;

	};



	this.extend = function(prop, extender, params, proto) {

		if (!prop || arguments.length < 2) return;



		if (typeof extender === 'object' && typeof params === 'function') {

			_sg[prop] = params.bind(extender);

			return;

		}



		if (arguments.length > 2 && typeof extender === 'function') {

			if (typeof proto === 'object') {

				for (var protoProp in proto) {

					if (!Object.prototype.hasOwnProperty.call(proto, protoProp))

						continue;

					extender.prototype[protoProp] = proto[protoProp];

				}

			}



			_sg[prop] = new extender(params);

			return;

		}



		_sg[prop] = extender;

	};



	this.route = function(rule, modules) {

		rule = rule || '*';

		modules = modules || [];



		modules.map(function(moduleName) {

			if (!_routes.hasOwnProperty(moduleName)) {

				_routes[moduleName] = {

					rules: []

				};

			}

			_routes[moduleName].rules.push(rule);

		});

	};



	this.triggerCustom = function(element, name, data, bubbles, cancelable) {

		if (!window.CustomEvent || !element || !element.dispatchEvent) return;



		var event = new CustomEvent(name, {

			detail: data,

			bubbles: !!bubbles,

			cancelable: !!cancelable

		});



		element.dispatchEvent(event);

	};



	this.go = function(route) {

		if (_config.routeHash) {

			location.hash = '#' + route;

		} else {

			var url = new URL(route, document.baseURI);

			location.pathname = url.pathname;

		}



		_dispatch.call(_sg);

	};



	this.on = function(eventName, handler) {

		if (!eventName || typeof handler !== 'function') {

			return;

		}



		if (!this._sgStore.handlers[eventName]) {

			this._sgStore.handlers[eventName] = [];

		}



		this._sgStore.handlers[eventName].push(handler);

	};



	this.trigger = function(eventName, params) {

		if (!this._sgStore.handlers.hasOwnProperty(eventName)) {

			return;

		}



		this._sgStore.handlers[eventName].map(function(handler) {

			handler.apply(this, params);

		}, this);

	};



	this.getState = function(stateName) {

		if (

			!this._sgStore ||

			!this._sgStore.states ||

			!this._sgStore.states.hasOwnProperty(stateName)

		) {

			return null;

		}



		return this._sgStore.states[stateName];

	};



	this.setState = function(stateName, value) {

		if (arguments.length < 2) {

			return false;

		}



		if (!this._sgStore.states.hasOwnProperty(stateName)) {

			this._sgStore.states[stateName] = null;

		}



		var oldValue = this._sgStore.states[stateName];

		this._sgStore.states[stateName] = value;



		if (

			typeof value === 'object' ||

			typeof value === 'function' ||

			oldValue !== value

		) {

			this.trigger('stateChanged', [stateName, oldValue, value]);

		}



		return true;

	};



	this.extendConstructor = function() {

		this.prototype._sgStore = {

			handlers: {},

			states: {}

		};



		this.prototype.class = _sg.class;

		this.prototype.on = _sg.on;

		this.prototype.trigger = _sg.trigger;

		this.prototype.getState = _sg.getState;

		this.prototype.setState = _sg.setState;

	};



	this.logError = function(e) {

		var err = _dataToError(e);



		var data = {

			level: err.level,

			message: err.message,

			data: JSON.stringify(err)

		};



		console.warn('FRONTEND ERROR: ', err);

	};



	this.codes = new (function() {

		var _keys = {

				backspace: 8,

				tab: 9,

				enter: 13,

				shift: 16,

				ctrl: 17,

				alt: 18,

				esc: 27,

				space: 32,

				left: 37,

				up: 38,

				right: 39,

				down: 40

			},

			_chars = {

				space: 32

			};



		this.key = function(name) {

			return _keys[name] || 0;

		};



		this.char = function(name) {

			return _chars[name] || 0;

		};

	});



	this.module = function(name, f) {

		if (typeof f !== 'function') {

			return;

		}



		_sg.extendConstructor.call(f);

		_sg[name] = new f();



		_sg[name].setState('inited', false);

		_sg[name].setState('involved', false);



		_modulesData[name] = {};



		_modulesData[name].readyPromise = new Promise(function(resolve, reject) {

			if (this.getState('ready') === true) {

				resolve();

				return;

			}



			this.on('stateChanged', function(stateName, oldValue, value) {

				if (stateName === 'ready' && value === true) {

					resolve();

				}

			});

		}.bind(_sg[name]));

	};



	this.ready = function(handler) {

		this.on('ready', handler);

	};



	this.load = function(handler) {

		this.on('load', handler);

	};



	this.run = function(config) {

		_config = config;

		if (_config.api) {

			_sg.api.setConfig(_config.api);

		}

		_dispatch.call(_sg);

	};



	_initCore.call(_sg);

})(window, document);
if (!String.prototype.startsWith) {
	Object.defineProperty(String.prototype, 'startsWith', {
		enumerable: false,
		configurable: false,
		writable: false,
		value: function(searchString, position) {
			position = position || 0;
			return this.indexOf(searchString, position) === position;
		}
	});
}

if (!String.prototype.trim) {
	(function() {
		String.prototype.trim = function() {
			return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
		};
	})();
}

sg.string = {
	match: function(str, rule) {
		if (rule === '*') {
			return true;
		}

		if (rule.indexOf('*') === -1) {
			return str === rule;
		}

		return new RegExp('^' + rule.split('*').join('.+') + '$').test(str);
	},

	wordEnding: function(num, str1, str2, str3) {
		var val = num % 100;

		if (val > 10 && val < 20) {
			return str3;
		} else {
			val = num % 10;
			if (val == 1) {
				return str1;
			} else if (val > 1 && val < 5) {
				return str2;
			} else {
				return str3;
			}
		}
	}
};

sg.views = (new function() {
	var _module = this,
		views = {},
		formatters = {},
		templates = [];


	var ViewEntity = function (viewName, templatePath) {
		var _entity = this;

		if (!views[viewName]) {
			throw new Error('Unknown view');
		}

		this.config = views[viewName];
		this.node = null;

		if (!templatePath) {
			templatePath = this.config.defaultTemplatePath;
		}

		

		this.nodeReady = _module.createNodeFromTemplate(templatePath).then(function (tpl) {
			_entity.node = tpl.content.firstChild.cloneNode(true);
			return _entity.node;
		});
	};

	ViewEntity.prototype.update = function (data) {
		this.nodeReady.then(function (node) {
			for (var fieldName in data) {
				if (data.hasOwnProperty(fieldName)) {
					var formatter = this.getFormatter(fieldName);

					formatter.call(
						this,
						node.querySelector('.js-view-' + fieldName),
						data[fieldName]
					);
				}
			}
		}.bind(this));
	};

	ViewEntity.prototype.appendTo = function (container) {
		this.nodeReady.then(function (node) {
			container.appendChild(node);
		}.bind(this));
	};

	ViewEntity.prototype.getFormatter = function (fieldName) {
		var formatterName = this.config.fields[fieldName] || this.config.defaultFormatterName;

		return formatters[formatterName] || function (node, data) {
			node.innerHTML = data;
		};
	};

	this.defineFormatter = function (name, formatter) {
		formatters[name] = formatter;
	};

	this.define = function (viewName, config) {
		views[viewName] = config;
	};

	this.create = function (viewName, templatePath) {
		return new ViewEntity(viewName, templatePath);
	};

	this.createNodeFromTemplate = function (path) {
		path = new URL(path, document.baseURI).href;

		var tpl = null;
		for (var i = templates.length - 1; i >= 0; i--) {
			if (path === templates[i].path) {
				tpl = templates[i];
				break;
			}
		};

		if (!tpl) {
			tpl = { path: path };
			templates.push(tpl);
		}

		if (!tpl.ready) {
			tpl.ready = fetch(path)
				.then(function (response) { return response.text() })
				.then(function (html) {
					tpl.node = document.createElement('TEMPLATE');
					tpl.node.innerHTML = html;
					document.body.appendChild(tpl.node);
					return tpl.node;
				})
				.catch(function () {
					console.warn('Template loading error', arguments);
				});
		}

		return tpl.ready;
	};
});
sg.views.define('auth', {
	defaultTemplatePath: './templates/auth.html',
	defaultFormatterName: 'content',
	fields: {
		body: 'content'
	}
});

sg.views.define('chat-item', {
	defaultTemplatePath: './templates/chat-item.html',
	defaultFormatterName: 'content',
	fields: {
		body: 'content'
	}
});

sg.views.define('messenger', {
	defaultTemplatePath: './templates/messenger.html',
	defaultFormatterName: 'content',
	fields: {
		body: 'content'
	}
});

sg.views.defineFormatter('content', function (node, data) {
	if(node) node.innerHTML = data;
});
sg.module('auth', function() {
	var _module = this,
		_baseView = null;

	this.on('init', function() {

		sg.getRoot().innerHTML = '';
		_baseView = sg.views.create('auth');
		_baseView.appendTo(sg.getRoot());
		_baseView.nodeReady.then(function () {
			var formAuth = _baseView.node.querySelector('.js-form-auth'),
				formSignIn = _baseView.node.querySelector('.js-form-signin');

			formAuth.addEventListener('submit', function (e) {
				e.preventDefault();

				var phoneField = this.elements.phone;
				phoneField.classList.remove('error');
				this.classList.add('loading');

				sg.api.sendCode(phoneField.value).then(result => {
					formSignIn.elements.phone.value = phoneField.value;
					formSignIn.elements.hash.value = result.phone_code_hash;
					formSignIn.classList.remove('hide');
					formAuth.classList.add('hide');
					this.classList.remove('loading');

					//result.phone_registered
					//result.is_password
				}, err => {
					console.warn(err);
					this.classList.remove('loading');
					phoneField.classList.add('error');
				});
			}, false);

			formSignIn.addEventListener('submit', function (e) {
				e.preventDefault();

				var codeField = this.elements.code;
				codeField.classList.remove('error');
				this.classList.add('loading');

				sg.api.signIn(this.elements.phone.value, this.elements.hash.value, codeField.value).then(result => {
					this.classList.remove('loading');
					sg.go('/messenger/');
				}, err => {
					console.warn(err);
					this.classList.remove('loading');
					codeField.classList.add('error');
				});
			}, false);
		});
		
		//_baseView.update();
	});

	// INIT
	sg.api.getUserInfo().then(user => {
		if (user.id) {
			sg.go('/messenger/');
			return;
		}

		_module.setState('ready', true);
	});
});
/*sg.module('form', function() {
	const LOADING_SUFFIX = '_loading';

	var _module = this,

		_init = function() {
			var forms = document.getElementsByClassName('js-form');
			for(var i = 0; i < forms.length; i++) {
				if (forms[i].formHandler) return true;
				forms[i].formHandler = new FormHandler(forms[i]);
			}

			var formsSubmit = document.getElementsByClassName('js-form-submitter');
			for(var i = 0; i < formsSubmit.length; i++) {
				if (formsSubmit[i].formSubmitter) return true;
				formsSubmit[i].formSubmitter = new Submitter(formsSubmit[i]);
			}

			var formsValidate = document.getElementsByClassName('js-form-validator');
			for(var i = 0; i < formsValidate.length; i++) {
				if (formsValidate[i].formValidator) return true;
				formsValidate[i].formValidator = new Validator(formsValidate[i]);
			}
		},
		_getFormData = function(element) {
			return new FormData(element);
		},
		_validateForm = function(form) {
			var formValid = true;

			if ('reportValidity' in form) {
				formValid = form.reportValidity();
			}

			if (!formValid) return false;

			if ('checkValidity' in form && !form.checkValidity()) {
				for (var i = 0, element; (element = form.elements[i]); i++) {
					if (typeof element.willValidate !== 'undefined') {
						if (!element.checkValidity()) {
							formValid = false;
							_applyElementValidity(element, false);
						}
					}
				}
			}

			if (formValid) {
				formValid = _validateFormSilent(form);
			}

			return formValid;
		},
		_validateFormSilent = function(form) {
			var formValid = true;

			for (var i = 0, element; (element = form.elements[i]); i++) {
				if (
					element.validity &&
					typeof element.willValidate !== 'undefined'
				) {
					if (!element.validity.valid) {
						formValid = false;
						break;
					}
				}
			}

			return formValid;
		},
		_applyElementValidity = function(element, valid, message, event) {
			if (event) {
				event.preventDefault();
			}

			if (
				!element ||
				'length' in element ||
				!element.nodeName ||
				(element.nodeName !== 'INPUT' &&
					element.nodeName !== 'TEXTAREA' &&
					element.nodeName !== 'SELECT')
			) {
				if (message) alert(message);
				return true;
			}

			var fieldWrap = element.parentNode;

			valid = !!valid;

			if (valid) {
				fieldWrap.removeClass('error');
				fieldWrap.addClass('valid');
			} else {
				$fieldWrap.addClass('error');
				$fieldWrap.removeClass('valid');
				message = message || element.validationMessage;

				if (message) alert(message);
			}

			return valid;
		},
		_finalFormSubmitCatcher = function(reason) {
			if (reason && reason.handled) return;
			alert(reason);
		};
	
	var FormHandler = function(form) {
		console.log('1111');
		form.addEventListener(
			'submit',
			this.submitHandler,
			false
		);
	};

	FormHandler.prototype.submitHandler = function(e) {
		e.preventDefault();

		var form = this,
			dataType = form.dataset.form_type || 'text';

		if (_module.isFormLocked(form)) {
			if (_validateFormSilent(form)) {
				alert('Пожалуйста, подождите! Форма уже отправляется.');
			} else {
				_validateForm(form);
			}

			return;
		}
		_module.startLoading(form);

		for (var i = 0, element; (element = form.elements[i]); i++) {
			_applyElementValidity(element, true);
		}

		var request = Air.req(form.action || '.', {
			method: form.method || 'GET',
			data: _getFormData(form),
			dataType: dataType
		})
			.then(result => {
				_module.finishLoading(form);

				if (dataType !== 'json') {
					return result;
				}

				if (result && result.status && result.status !== 'error') {
					if (form.dataset.formReset) {
						form.reset();
					}
					return result;
				}

				if (!result) {
					return Promise.reject({
						status: 0,
						message: 'Empty json'
					});
				}

				var invalidFields =
					result.invalid || (result.data && result.data.invalid);
				if (invalidFields) {
					return Promise.reject({
						status: 0,
						message: result.message || 'Validation failed',
						invalid: invalidFields
					});
				}

				return Promise.reject(result);
			})
			.catch(reason => {
				_module.finishLoading(form);

				var handled = Promise.reject({ status: 0, handled: 1 });

				if (reason && reason.invalid) {
					var validationApplied = false;

					for (var field in reason.invalid) {
						if (!form.elements[field]) {
							Air.notifier.error(
								'Упс!',
								reason.invalid[field]
							);
							continue;
						}
						validationApplied = true;
						_applyElementValidity(
							form.elements[field],
							false,
							reason.invalid[field]
						);
					}

					if (validationApplied) return handled;
				}

				Air.api.generalError(reason);
				return handled;
			});

		var actionStr = $(form).data('form-action');

		if (!actionStr) {
			return;
		}

		var action = Air.action.getFunc(actionStr);

		if (action) {
			action(request, form).catch(_finalFormSubmitCatcher);
		}
	};

	var Submitter = function(form) {
		this.timer = null;
		this.form = form;
		this.delay = form.dataset.submitter_delay;

		form.addEventListener(
			form.dataset.submitter_events || 'change',
			this.queue.bind(this),
			false
		);
	};

	Submitter.prototype.queue = function(e) {
		if (this.delay) {
			clearTimeout(this.timer);
			this.timer = setTimeout(
				_module.submit(this.form, true),
				this.delay
			);
		} else {
			_module.submit(this.form, true);
		}
	};

	var Validator = function(form) {
		this.form = form;
		//this.external.bind(form);
		//form.noValidate = true;
		

		$(form).on('input focus', 'input, textarea, select', function(e) {
			if (this.validity && this.validity.valid) {
				_applyElementValidity(this, true);
			}

			if (_validateFormSilent(form)) {
				_module.formUnlock(form);
			}
		});

		$(form).on('change', 'input, textarea, select', function(e) {
			if (this.validity && this.validity.valid) {
				_applyElementValidity(this, true);
			} else {
				this.checkValidity();
			}

			if (_validateFormSilent(form)) {
				_module.formUnlock(form);
			}
		});

		$(form).on('reset', function(e) {
			if (!_validateFormSilent(this)) {
				_module.formLock(this);
			}
		});

		for (var i = 0, element; (element = form.elements[i]); i++) {
			element.addEventListener('invalid', function(e) {
				_applyElementValidity(this, false, null, e);
			});
		}

		if (!_validateFormSilent(form)) {
			_module.formLock(form);
		}
	};

	this.test = function(request, form) {
		sg.l('Form module test: request started for ', form);
		request
			.then(result => sg.l('Form module test: result', result))
			.catch(error => sg.l('Form module test: error', error));
	};

	this.getSubmitElem = function(form) {
		if (!form._formSubmitElem) {
			form._formSubmitElem = null;

			if (form && form.elements) {
				for (var i = 0, element; (element = form.elements[i]); i++) {
					if (element.type === 'submit') {
						form._formSubmitElem = element;
						break;
					}
				}
			}
		}

		return form._formSubmitElem;
	};

	this.startLoading = function(elem) {
		elem.classList.add(elem.nodeName.toLowerCase() + LOADING_SUFFIX);
		_module.formLock(elem);
	};

	this.finishLoading = function(elem) {
		elem.classList.remove(elem.nodeName.toLowerCase() + LOADING_SUFFIX);
		_module.formUnlock(elem);
	};

	this.formLock = function(elem) {
		elem._isFormLocked = 1;
		var submitElem = _module.getSubmitElem(elem);
		if (submitElem) submitElem.disabled = true;
	};

	this.formUnlock = function(elem) {
		elem._isFormLocked = 0;
		var submitElem = _module.getSubmitElem(elem);
		if (submitElem) submitElem.disabled = false;
	};

	this.isFormLocked = function(elem) {
		return !!(elem && elem._isFormLocked);
	};

	this.submit = function(form, validate) {
		if (!'submit' in form) {
			return false;
		}

		if (validate && !_validateForm(form)) {
			return false;
		}

		var event = new Event('submit', { bubbles: true, cancelable: true });
		form.dispatchEvent(event);

		if (!event.defaultPrevented) {
			form.submit();
			return true;
		}

		return false;
	};

	this.on('init', function(params) {
		_init();
	});

	this.on('reinit', function(params) {
		_init();
	});

	this.setState('ready', true);
});
*/
sg.module('messenger', function() {
	var _module = this,
		_baseView = null,
		_user = null;

	this.on('init', function() {
		sg.getRoot().innerHTML = '';
		_baseView = sg.views.create('messenger');
		_baseView.appendTo(sg.getRoot());
		_baseView.nodeReady.then(function () {
			sg.api.getDialogs().then(data => {
				data.result.chats.forEach(element => {
					var chatItem = sg.views.create('chat-item');
					chatItem.update({
						title: element.title
					});
					chatItem.appendTo(_baseView.node.querySelector('.chats__list'));
				});
			});
		});
	});

	// INIT

	sg.api.getUserInfo().then(user => {
		if (!user.id) {
			sg.go('/auth/');
			return;
		}

		_user = user;
		_module.setState('ready', true);
	});
});
sg.module('widget-select', function() {
	this.on('init', function() {
		//console.log(document.querySelector('.js-widget-select'))
	});

	this.setState('ready', true);
});

sg.route('*', [
	'widget-select',
	'form'
]);

sg.route('/', [
	'auth'
]);

sg.route('/auth/', [
	'auth'
]);

sg.route('/messenger/', [
	'messenger'
]);

sg.ready(function() {
	sg.html.className = sg.html.className.replace(
		'dom-building',
		'dom-ready'
	);

	sg.run({
		root: document.getElementById('app'),
		routeHash: true,
		api: {
			app: {
				id: 1038057, // App api_id
				hash: 'c9b1eece16427bb5158122905769d09c', // App api_hash
				version: '1.0.0' // App version
			},
			server: {
				test: [
					{
						id: 2, // DC ID
						host: '149.154.167.40',
						port: 443
					}
				],
				production: [
					{
						id: 2, // DC ID
						host: '149.154.167.50',
						port: 443
					}
				]
			}
		}
	});
});

sg.load(function() {
	sg.html.className = sg.html.className.replace(
		'doc-loading',
		'doc-loaded'
	);
});